import { AbstractControl, ValidationErrors } from '@angular/forms';

const greaterThenZeroValidationError = { 'greater-then-zero': true };

export const greaterThenZeroValidator = (control: AbstractControl): ValidationErrors | null => {
  return control.value > 0 ? null : greaterThenZeroValidationError;
};
